import { Component, Input } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import {
  PersonGbMasterDetailEntryMeta,
  PersonGbMasterId,
  PersonGbVersionDetailEntryMeta,
  PersonStammMasterListEntryMeta
} from '../../../../core/gb-api';
import { NavTarget } from 'app/shared/components/link/link.component';
import { ContentHeaderComponent } from '../../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../../shared/components/title/title.component';
import { KompaktPersongbComponent } from '../../../../shared/kompaktdarstellung/persongb/kompakt-persongb.component';
import { HistoryDirective } from '../../../../shared/directives/history.directive';
import { TitleFunctionbarComponent } from '../../../../shared/components/title-functionbar/title-functionbar.component';
import { LinkComponent } from '../../../../shared/components/link/link.component';
import { TranslatePipe } from '@ngx-translate/core';
import AuskunftsperreEnum = PersonStammMasterListEntryMeta.AuskunftsperreEnum;

@Component({
  selector: 'cap-persongb-detail-title',
  templateUrl: './persongb-detail-title.component.html',
  styleUrls: ['./persongb-detail-title.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    KompaktPersongbComponent,
    HistoryDirective,
    TitleFunctionbarComponent,
    LinkComponent,
    TranslatePipe
  ]
})
export class PersongbDetailTitleComponent {
  navTargets = NavTarget;

  @Input()
  public personGbVersion: PersonGbVersionDetailEntryMeta;
  @Input()
  public personGbMasterId: PersonGbMasterId;
  @Input()
  public showTitlebutton = false;
  @Input()
  auskunftsperre?: PersonGbMasterDetailEntryMeta.HasAuskunftssperreEnum;

  constructor() {
    keysToTranslate<string>(['Grundbuchperson', 'VergleichMitZpvPerson']);
  }

  getAuskunftsperre(personGbHasAuskunftssperre: PersonGbMasterDetailEntryMeta.HasAuskunftssperreEnum): AuskunftsperreEnum {
    return personGbHasAuskunftssperre === PersonGbMasterDetailEntryMeta.HasAuskunftssperreEnum.AUSKUNFT_SPERRE
      ? AuskunftsperreEnum.AUSKUNFT_SPERRE
      : AuskunftsperreEnum.KEINE;
  }
}
